import AirConditioning from '@spa/shared/svg/air-conditioning';
import AirConditioningNot from '@spa/shared/svg/air-conditioning-not';
import Accessibility from '@spa/shared/svg/accessibility';
import AccessibilityNot from '@spa/shared/svg/accessibility-not';
import BicycleParking from '@spa/shared/svg/bicycle-parking';
import Bathtub from '@spa/shared/svg/bathtub';
import BathtubNot from '@spa/shared/svg/bathtub-not';
import BedlinenTowels from '@spa/shared/svg/bed-linen-and-towels';
import BedlinenTowelsNot from '@spa/shared/svg/bed-linen-and-towels-not';
import CableTV from '@spa/shared/svg/cable-tv';
import CableTVNot from '@spa/shared/svg/cable-tv-not';
import Coffee from '@spa/shared/svg/coffee';
import CoffeeTable from '@spa/shared/svg/coffee-table';
import CoffeeTableNot from '@spa/shared/svg/coffee-table-not';
import Cutlery from '@spa/shared/svg/cutlery';
import Elevator from '@spa/shared/svg/elevator';
import GameController from '@spa/shared/svg/game-controller';
import Gym from '@spa/shared/svg/gym';
import CentralHeating from '@spa/shared/svg/central-heating';
import CentralHeatingNot from '@spa/shared/svg/central-heating-not';
import Library from '@spa/shared/svg/library';
import OutdoorArea from '@spa/shared/svg/outdoor-area';
import OutdoorAreaNot from '@spa/shared/svg/outdoor-area-not';
import Parking from '@spa/shared/svg/parking';
import Pool from '@spa/shared/svg/pool';
import SecurityCameras from '@spa/shared/svg/security-cameras';
import Support from '@spa/shared/svg/support';
import Washing from '@spa/shared/svg/washing';
import WC from '@spa/shared/svg/wc';
import Wifi from '@spa/shared/svg/wi-fi';
import WifiNot from '@spa/shared/svg/wi-fi-not';
import Balcony from '@spa/shared/svg/balcony';
import BalconyNot from '@spa/shared/svg/balcony-not';
import Chairs from '@spa/shared/svg/chairs';
import ChairsNot from '@spa/shared/svg/chairs-not';
import Desk from '@spa/shared/svg/desk';
import DeskNot from '@spa/shared/svg/desk-not';
import DishesCutlery from '@spa/shared/svg/dishes-cutlery';
import DishesCutleryNot from '@spa/shared/svg/dishes-cutlery-not';
import DishWasher from '@spa/shared/svg/dishwasher';
import DishWasherNot from '@spa/shared/svg/dishwasher-not';
import Dryer from '@spa/shared/svg/dryer';
import DryerNot from '@spa/shared/svg/dryer-not';
import ElevatorNot from '@spa/shared/svg/elevator-not';
import Freezer from '@spa/shared/svg/freezer';
import FreezerNot from '@spa/shared/svg/freezer-not';
import Fridge from '@spa/shared/svg/fridge';
import FridgeNot from '@spa/shared/svg/fridge-not';
import Oven from '@spa/shared/svg/oven';
import OvenNot from '@spa/shared/svg/oven-not';
import PotsPans from '@spa/shared/svg/pots-pans';
import PotsPansNot from '@spa/shared/svg/pots-pans-not';
import Shower from '@spa/shared/svg/shower';
import ShowerNot from '@spa/shared/svg/shower-not';
import Sink from '@spa/shared/svg/sink';
import SinkNot from '@spa/shared/svg/sink-not';
import SofaBed from '@spa/shared/svg/sofa-bed';
import SofaBedNot from '@spa/shared/svg/sofa-bed-not';
import Sofa from '@spa/shared/svg/sofa';
import SofaNot from '@spa/shared/svg/sofa-not';
import Stove from '@spa/shared/svg/stove';
import StoveNot from '@spa/shared/svg/stove-not';
import Table from '@spa/shared/svg/table';
import TableNot from '@spa/shared/svg/table-not';
import Toilet from '@spa/shared/svg/toilet';
import ToiletNot from '@spa/shared/svg/toilet-not';
import Tv from '@spa/shared/svg/tv';
import TvNot from '@spa/shared/svg/tv-not';
import WashingMachine from '@spa/shared/svg/washing-machine';
import WashingMachineNot from '@spa/shared/svg/washing-machine-not';
import Window from '@spa/shared/svg/window';
import WindowNot from '@spa/shared/svg/window-not';
import Reception from '@spa/shared/svg/reception';
import Cinema from '@spa/shared/svg/cinema';
import SecurityOffice from '@spa/shared/svg/security-office';
import MaintenanceTeam from '@spa/shared/svg/maintenance-team';
import Study from '@spa/shared/svg/study';
import FloorPlan from '@spa/shared/svg/floor-plan';
import ChestOfDrawers from '@spa/shared/svg/chest-of-drawers';
import ChestOfDrawersNot from '@spa/shared/svg/chest-of-drawers-not';
import Wardrobe from '@spa/shared/svg/wardrobe-new';
import Microwave from '@spa/shared/svg/microwave';
import MicrowaveNot from '@spa/shared/svg/microwave-not';
import Unfurnished from '@spa/shared/svg/unfurnished';
import Towels from '@spa/shared/svg/towels';
import TowelsNot from '@spa/shared/svg/towels-not';
import Lock from '@spa/shared/svg/lock';
import LockNot from '@spa/shared/svg/lock-not';
import WardrobeNot from '@spa/shared/svg/wardrobe-new-not';

export const SERVICES_FEATURES = {
  area: {
    Component: FloorPlan,
    translation: '{{area}} m²',
    translation_old: 'services_features.area'
  },
  'study-area': {
    Component: Study,
    translation: 'Study area',
    translation_old: 'services_features.study_area'
  },
  library: {
    Component: Library,
    translation: 'Library',
    translation_old: 'services_features.library'
  },
  wardrobe: {
    Component: Wardrobe,
    translation: 'Wardrobe',
    translation_old: 'services_features.wardrobe'
  },
  'wardrobe-not': {
    Component: WardrobeNot,
    translation: 'Wardrobe',
    translation_old: 'services_features.wardrobe'
  },
  gym: {
    Component: Gym,
    translation: 'Gym',
    translation_old: 'services_features.gym'
  },
  'dining-room': {
    Component: Cutlery,
    translation: 'Dining room',
    translation_old: 'services_features.dining_room'
  },
  'bike-storage': {
    Component: BicycleParking,
    translation: 'Bike storage',
    translation_old: 'services_features.bike_storage'
  },
  'entertainment-area': {
    Component: GameController,
    translation: 'Entertainment area',
    translation_old: 'services_features.entertainment_area'
  },
  wc: {
    Component: WC,
    translation: 'WC',
    translation_old: 'services_features.wc'
  },
  reception: {
    Component: Reception,
    translation: 'Reception',
    translation_old: 'services_features.reception'
  },
  kitchen: {
    Component: Cutlery,
    translation: 'Kitchen',
    translation_old: 'services_features.common_kitchen'
  },
  bathroom: {
    Component: WC,
    translation: 'Bathroom',
    translation_old: 'services_features.common_bathroom'
  },
  'chest-of-drawers': {
    Component: ChestOfDrawers,
    translation: 'Chest of drawers',
    translation_old: 'services_features.chest_of_drawers'
  },
  'chest-of-drawers-not': {
    Component: ChestOfDrawersNot,
    translation: 'Chest of drawers',
    translation_old: 'services_features.chest_of_drawers'
  },
  'private-bathroom': {
    Component: Bathtub,
    translation: 'Private bathroom',
    translation_old: 'services_features.private_bathroom'
  },
  'private-wc': {
    Component: WC,
    translation: 'Private WC',
    translation_old: 'services_features.private_wc'
  },
  bathtub: {
    Component: Bathtub,
    translation: 'Bathtub',
    translation_old: 'services_features.bathtub'
  },
  'bathtub-not': {
    Component: BathtubNot,
    translation: 'Bathtub',
    translation_old: 'services_features.bathtub'
  },
  'laundry-facilities': {
    Component: Washing,
    translation: 'Laundry facilities',
    translation_old: 'services_features.laundry_facilities'
  },
  parking: {
    Component: Parking,
    translation: 'Parking',
    translation_old: 'services_features.parking'
  },
  'cinema-room': {
    Component: Cinema,
    translation: 'Cinema room',
    translation_old: 'services_features.cinema_room'
  },
  'coffee-bar': {
    Component: Coffee,
    translation: 'Coffee bar',
    translation_old: 'services_features.coffee_bar'
  },
  'coffee-table': {
    Component: CoffeeTable,
    translation: 'Coffee table',
    translation_old: 'services_features.coffee_table'
  },
  'coffee-table-not': {
    Component: CoffeeTableNot,
    translation: 'Coffee table',
    translation_old: 'services_features.coffee_table'
  },
  pool: {
    Component: Pool,
    translation: 'Pool',
    translation_old: 'services_features.pool'
  },
  'outdoor-area': {
    Component: OutdoorArea,
    translation: 'Outdoor area',
    translation_old: 'services_features.outdoor_area'
  },
  'outdoor-area-not': {
    Component: OutdoorAreaNot,
    translation: 'Outdoor area',
    translation_old: 'services_features.outdoor_area'
  },
  'maintenance-team': {
    Component: MaintenanceTeam,
    translation: 'Maintenance team',
    translation_old: 'services_features.maintenance_team'
  },
  cameras: {
    Component: SecurityCameras,
    translation: 'Cameras',
    translation_old: 'services_features.cameras'
  },
  'wi-fi': {
    Component: Wifi,
    translation: 'Wi-Fi',
    translation_old: 'services_features.wifi'
  },
  'wi-fi-not': {
    Component: WifiNot,
    translation: 'Wi-Fi',
    translation_old: 'services_features.wifi'
  },
  'cable-tv': {
    Component: CableTV,
    translation: 'Cable Tv',
    translation_old: 'services_features.cable_tv'
  },
  'cable-tv-not': {
    Component: CableTVNot,
    translation: 'Cable Tv',
    translation_old: 'services_features.cable_tv'
  },
  'central-heating': {
    Component: CentralHeating,
    translation: 'Central heating',
    translation_old: 'services_features.central_heating'
  },
  'central-heating-not': {
    Component: CentralHeatingNot,
    translation: 'Central heating',
    translation_old: 'services_features.central_heating'
  },
  'air-conditioning': {
    Component: AirConditioning,
    translation: 'Air conditioning',
    translation_old: 'services_features.air_conditioning'
  },
  'air-conditioning-not': {
    Component: AirConditioningNot,
    translation: 'Air conditioning',
    translation_old: 'services_features.air_conditioning'
  },
  surveillance: {
    Component: SecurityCameras,
    translation: 'Surveillance',
    translation_old: 'services_features.surveillance'
  },
  elevator: {
    Component: Elevator,
    translation: 'Elevator',
    translation_old: 'services_features.elevator'
  },
  'elevator-not': {
    Component: ElevatorNot,
    translation: 'Elevator',
    translation_old: 'services_features.elevator'
  },
  accessibility: {
    Component: Accessibility,
    translation: 'Accessibility',
    translation_old: 'services_features.accessibility'
  },
  'accessibility-not': {
    Component: AccessibilityNot,
    translation: 'Accessibility',
    translation_old: 'services_features.accessibility'
  },
  'security-office': {
    Component: SecurityOffice,
    translation: 'Security office',
    translation_old: 'services_features.security_office'
  },
  'onsite-support': {
    Component: Support,
    translation: 'Onsite support',
    translation_old: 'services_features.onsite_support'
  },
  'bed-linen': {
    Component: BedlinenTowels,
    translation: 'Bed linen',
    translation_old: 'services_features.bed_linen'
  },
  'bed-linen-not': {
    Component: BedlinenTowelsNot,
    translation: 'Bed linen',
    translation_old: 'services_features.bed_linen'
  },
  towels: {
    Component: Towels,
    translation: 'Towels',
    translation_old: 'services_features.towels'
  },
  'towels-not': {
    Component: TowelsNot,
    translation: 'Towels',
    translation_old: 'services_features.towels'
  },
  'bed-linen-and-towels': {
    Component: BedlinenTowels,
    translation: 'Bed linen and towels',
    translation_old: 'services_features.bed_linen_and_towels'
  },
  'bed-linen-and-towels-not': {
    Component: BedlinenTowelsNot,
    translation: 'Bed linen and towels',
    translation_old: 'services_features.bed_linen_and_towels'
  },
  balcony: {
    Component: Balcony,
    translation: 'Balcony',
    translation_old: 'services_features.balcony'
  },
  'balcony-not': {
    Component: BalconyNot,
    translation: 'Balcony',
    translation_old: 'services_features.balcony'
  },
  chairs: {
    Component: Chairs,
    translation: 'Chairs',
    translation_old: 'services_features.chairs'
  },
  'chairs-not': {
    Component: ChairsNot,
    translation: 'Chairs',
    translation_old: 'services_features.chairs'
  },
  desk: {
    Component: Desk,
    translation: 'Desk',
    translation_old: 'services_features.desk'
  },
  'desk-not': {
    Component: DeskNot,
    translation: 'Desk',
    translation_old: 'services_features.desk'
  },
  'dishes-cutlery': {
    Component: DishesCutlery,
    translation: 'Dishes and cutlery',
    translation_old: 'services_features.dishes_cutlery'
  },
  'dishes-cutlery-not': {
    Component: DishesCutleryNot,
    translation: 'Dishes and cutlery',
    translation_old: 'services_features.dishes_cutlery'
  },
  dishwasher: {
    Component: DishWasher,
    translation: 'Dishwasher',
    translation_old: 'services_features.dish_washer'
  },
  'dishwasher-not': {
    Component: DishWasherNot,
    translation: 'Dishwasher',
    translation_old: 'services_features.dish_washer'
  },
  lock: {
    Component: Lock,
    translation: 'Door lock',
    translation_old: 'services_features.lock'
  },
  'lock-not': {
    Component: LockNot,
    translation: 'Door lock',
    translation_old: 'services_features.lock'
  },
  dryer: {
    Component: Dryer,
    translation: 'Dryer',
    translation_old: 'services_features.dryer'
  },
  'dryer-not': {
    Component: DryerNot,
    translation: 'Dryer',
    translation_old: 'services_features.dryer'
  },
  freezer: {
    Component: Freezer,
    translation: 'Freezer',
    translation_old: 'services_features.freezer'
  },
  'freezer-not': {
    Component: FreezerNot,
    translation: 'Freezer',
    translation_old: 'services_features.freezer'
  },
  fridge: {
    Component: Fridge,
    translation: 'Fridge',
    translation_old: 'services_features.fridge'
  },
  'fridge-not': {
    Component: FridgeNot,
    translation: 'Fridge',
    translation_old: 'services_features.fridge'
  },
  microwave: {
    Component: Microwave,
    translation: 'Microwave',
    translation_old: 'services_features.microwave'
  },
  'microwave-not': {
    Component: MicrowaveNot,
    translation: 'Microwave',
    translation_old: 'services_features.microwave'
  },
  oven: {
    Component: Oven,
    translation: 'Oven',
    translation_old: 'services_features.oven'
  },
  'oven-not': {
    Component: OvenNot,
    translation: 'Oven',
    translation_old: 'services_features.oven'
  },
  'pots-pans': {
    Component: PotsPans,
    translation: 'Pots and pans',
    translation_old: 'services_features.pots_pans'
  },
  'pots-pans-not': {
    Component: PotsPansNot,
    translation: 'Pots and pans',
    translation_old: 'services_features.pots_pans'
  },
  shower: {
    Component: Shower,
    translation: 'Shower',
    translation_old: 'services_features.shower'
  },
  'shower-not': {
    Component: ShowerNot,
    translation: 'Shower',
    translation_old: 'services_features.shower'
  },
  sink: {
    Component: Sink,
    translation: 'Sink',
    translation_old: 'services_features.sink'
  },
  'sink-not': {
    Component: SinkNot,
    translation: 'Sink',
    translation_old: 'services_features.sink'
  },
  'sofa-bed': {
    Component: SofaBed,
    translation: 'Sofa bed',
    translation_old: 'services_features.sofa_bed'
  },
  'sofa-bed-not': {
    Component: SofaBedNot,
    translation: 'Sofa bed',
    translation_old: 'services_features.sofa_bed'
  },
  sofa: {
    Component: Sofa,
    translation: 'Sofa',
    translation_old: 'services_features.sofa'
  },
  'sofa-not': {
    Component: SofaNot,
    translation: 'Sofa',
    translation_old: 'services_features.sofa'
  },
  stove: {
    Component: Stove,
    translation: 'Stove',
    translation_old: 'services_features.stove'
  },
  'stove-not': {
    Component: StoveNot,
    translation: 'Stove',
    translation_old: 'services_features.stove'
  },
  table: {
    Component: Table,
    translation: 'Table',
    translation_old: 'services_features.table'
  },
  'table-not': {
    Component: TableNot,
    translation: 'Table',
    translation_old: 'services_features.table'
  },
  toilet: {
    Component: Toilet,
    translation: 'Toilet',
    translation_old: 'services_features.toilet'
  },
  'toilet-not': {
    Component: ToiletNot,
    translation: 'Toilet',
    translation_old: 'services_features.toilet'
  },
  tv: {
    Component: Tv,
    translation: 'Tv',
    translation_old: 'services_features.tv'
  },
  'tv-not': {
    Component: TvNot,
    translation: 'Tv',
    translation_old: 'services_features.tv'
  },
  unfurnished: {
    Component: Unfurnished,
    translation: 'Unfurnished',
    translation_old: 'services_features.unfurnished'
  },
  'washing-machine': {
    Component: WashingMachine,
    translation: 'Washing machine',
    translation_old: 'services_features.washing_machine'
  },
  'washing-machine-not': {
    Component: WashingMachineNot,
    translation: 'Washing machine',
    translation_old: 'services_features.washing_machine'
  },
  window: {
    Component: Window,
    translation: 'Window',
    translation_old: 'services_features.window'
  },
  'window-not': {
    Component: WindowNot,
    translation: 'Window',
    translation_old: 'services_features.window'
  }
};

export const PRIVATE_FEATURES = {
  bedroom: {
    ...SERVICES_FEATURES,
    bathroom: {
      Component: Bathtub,
      translation: 'Private bathroom',
      translation_old: 'services_features.private_bathroom'
    }
  }
};
